import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { CloseIcon } from "@icarius-icons";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { useSelector } from "react-redux";
import { getCheckCollaboratorsData } from "@icarius-pages/evaluationProcessDefinition/selectors";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";

const StyledDialog = withStyles({
  paper: {
    minWidth: "90%",
  },
})(Dialog);

const CheckCollaboratorsDialog = (props) => {

  const {
    open,
    processName,
    handleClose,
  } = props;

  const checkCollaboratorsData = useSelector(getCheckCollaboratorsData);
  const title = `${getLocalizedString("collaboratorsNotInProcess")}: ${processName}`;

  return (
    <StyledDialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      fullWidth={true}
      maxWidth={"md"}>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <CommonPage
          gridTitle={title}
          columnDefPage={'evaluationProcessDefinitionCheckCollaborators'}
          rowData={checkCollaboratorsData}
          gridHeight={'60vh'}
          hasSelectAll
          hasExpand
          hasHelp
          ignoreProcessesbyPath
        />
      </DialogContent>
    </StyledDialog>
  );
}

export default CheckCollaboratorsDialog;